import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { NavLink } from 'react-router-dom';
import ContactBg from '../assets/img/About/Image3.webp';
import NavbarData from '../data/navbar';
import Footer from '../components/Footer';
import image1 from '../assets/img/Contact/image1.webp';
import image2 from '../assets/img/Contact/image2.webp';
import image3 from '../assets/img/Contact/image3.webp';
import image4 from '../assets/img/Contact/image4.webp';

const Contact = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [message, setMessage] = useState('');

  const handleNavClick = (index) => setActiveIndex(index);

  const sendEmail = () => {
    if (!message.trim()) {
      alert("Please enter a message before sending.");
      return;
    }

    emailjs.send(
      'service_wa76lmp', // Your EmailJS service ID
      'template_ajr4fjb', // Your EmailJS template ID
      { message },
      '7CgziywId045J0XQp' // Your EmailJS public key (from dashboard)
    )
    .then((response) => {
      alert("Thank you for your comment. Your message sent successfully!");
      setMessage('');
    })
    .catch((error) => {
      console.error("FAILED...", error);
      alert(`Failed to send message: ${error}`);
  });
  };

  return (
    <section
      className="relative md:pt-12  pt-3 w-full h-auto md:h-auto bg-cover bg-center overflow-hidden"
      style={{ backgroundImage: `url(${ContactBg})` }}
    >
      <div className="absolute inset-0 bg-[#2a2a3a]/90 z-0" />

      <div className="relative z-10 text-gray-300">
        <div className="container leading-8">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="flex-1">
              <h2 className="text-2xl font-semibold mb-4">
                ABOUT <span className="text-[#90444D]">US</span>
              </h2>
              <p className="mb-4 leading-8">
                CCCEA is a non-governmental organization established and registered at the Ministry of Justice. It began its actual operation in November 2006.
              </p>
            </div>

            <div className="flex-1">
              <h2 className="text-2xl font-semibold uppercase mb-4">
                Our <span className="text-[#90444D]">Location</span>
              </h2>
              <div className="space-y-2">
                <div className="flex items-start space-x-2">
                  <i className="fa-solid fa-location-dot text-[#90444D]" />
                  <span>24 Kokeb Hintsa in front of the Eritrean Embassy , Addis Ababa, Ethiopia</span>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="fa-solid fa-envelope text-[#90444D]" />
                  <div>
                    <p>cccea@ccfcea.org</p>
                    <p>christaincare1@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="fa-solid fa-phone text-[#90444D]" />
                  <div>
                    <p>+251 116 66 28 80</p>
                    <p>+251 911 25 74 03</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="fa-solid fa-envelopes-bulk text-[#90444D]"></i>
                  <span>P.O.BOX 21154</span>
                </div>
              </div>
            </div>

            <div className="flex-1">
              <h2 className="text-2xl font-semibold uppercase mb-4">
                Navigate <span className="text-[#90444D]">To</span>
              </h2>
              <ul>
                {NavbarData.map((item, index) => (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      onClick={() => handleNavClick(index)}
                      className={({ isActive }) =>
                        `block px-3 py-2 rounded transition-all duration-200 ${
                          activeIndex === index || isActive
                            ? 'bg-[#90444D]/20 border-l-4 border-[#90444D] text-white font-medium'
                            : 'hover:text-[#90444D] text-gray-300'
                        }`
                      }
                    >
                      {item.title}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex-1">
              <h2 className="text-2xl font-semibold mb-4 uppercase">
                Our <span className="text-[#90444D]">Gallery</span>
              </h2>
              <div className="space-y-2">
                <div className="flex gap-2">
                  <img src={image1} alt="Gallery 1" className="w-1/2 h-24 object-cover border border-gray-400" />
                  <img src={image2} alt="Gallery 2" className="w-1/2 h-24 object-cover border border-gray-400" />
                </div>
                <div className="flex gap-2">
                  <img src={image3} alt="Gallery 3" className="w-1/2 h-24 object-cover border border-gray-400" />
                  <img src={image4} alt="Gallery 4" className="w-1/2 h-24 object-cover border border-gray-400" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-black/70 mt-8 py-8">
          <div className="container">
            <div className="flex flex-col md:flex-row gap-8">
              <h2 className="text-2xl font-bold uppercase text-white mb-2">
                Leave <span className="text-[#90444D]">Comment</span>
              </h2>
              <div className="flex space-x-4 items-center">
                <textarea
                  cols="50"
                  rows="1"
                  placeholder="Write your comment here..."
                  className="w-full md:w-auto flex-1 px-4 py-2 rounded bg-gray-800 text-white border border-gray-600"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                <button
                  className="bg-[#90444D] hover:bg-[#a14e57] text-white px-6 py-2 rounded"
                  onClick={sendEmail}
                >
                  SEND
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </section>
  );
};

export default Contact;
